var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_433_2429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4869 23C18.2572 23 18.0374 22.95 17.8277 22.85L11.995 19.98L6.16229 22.85C5.66291 23.1 5.07365 23.04 4.62421 22.72C4.17478 22.39 3.94506 21.84 4.02496 21.29L4.9538 14.85L0.419469 10.19C0.0299561 9.79 -0.0998816 9.21 0.0699062 8.68C0.239694 8.15 0.689132 7.76 1.23845 7.67L7.64044 6.56L10.6766 0.8C10.9363 0.31 11.4457 0 12.005 0C12.5643 0 13.0737 0.31 13.3333 0.8L16.3595 6.55L22.7615 7.66C23.3109 7.75 23.7603 8.15 23.9301 8.67C24.0999 9.2 23.97 9.78 23.5805 10.18L19.0562 14.84L19.985 21.28C20.0649 21.83 19.8352 22.38 19.3858 22.71C19.1261 22.9 18.8165 23 18.5069 23H18.4869ZM11.995 16.8C12.2247 16.8 12.4444 16.85 12.6542 16.95L16.5992 18.89L15.97 14.54C15.9001 14.08 16.0499 13.61 16.3795 13.28L19.4457 10.13L15.1211 9.38C14.6617 9.3 14.2722 9.01 14.0524 8.6L12.005 4.71L9.95755 8.6C9.73782 9.01 9.34831 9.3 8.88888 9.38L4.56429 10.13L7.63046 13.28C7.95006 13.61 8.10986 14.08 8.03994 14.54L7.41073 18.89L11.3558 16.95C11.5655 16.85 11.7952 16.8 12.015 16.8H11.995Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_2429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/StarOutlined.192f23ab.svg";
export { ForwardRef as ReactComponent };